import React from "react";

const ProjectSearch = ({ value, onChange }) => {
  return (
    <div className="project-search">
      <i className="fas fa-search project-search-icon" />

      <input
        type="text"
        className="project-search-input"
        placeholder="Search by name, ID, company, location..."
        value={value}
        onChange={(event) => onChange(event.target.value)}
      />
    </div>
  );
};

export default ProjectSearch;
